import React, { KeyboardEvent, useState } from 'react';
import { NavigateFunction } from 'react-router-dom';
import ResetPassword from '../../ResetPassword';
import Translate from '../../Translate/Translate';
import Alert, { Type } from '../../Alert';
import Input from '../Input/Input';
import useStores from '../../../hooks/useStores';

interface Props {
  navigate: NavigateFunction;
  toggle: () => void;
}

const Login = ({ navigate, toggle }: Props) => {
  const { authentication, user, cart } = useStores();
  const [message, setMessage] = useState('');
  const [resetVisible, setResetVisible] = useState(false);
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');

  const setResetVisibility = () => {
    setResetVisible((prev) => !prev);
  };

  const tryToAuthenticate = async () => {
    if (!loginEmail && !loginPassword) {
      setMessage('emailandpassword');
      return;
    }

    if (!loginEmail) {
      setMessage('email');
      return;
    }

    if (!loginEmail.includes('@') || !loginEmail.includes('.')) {
      setMessage('authemail');
      return;
    }

    if (!loginPassword) {
      setMessage('password');
      return;
    }

    setMessage('');

    authentication.loginEmail = loginEmail;
    authentication.loginPassword = loginPassword;

    try {
      await authentication.authenticate();
      await cart.create();
      await user.loadInfo();

      toggle();
      navigate(0);
    } catch (error: any) {
      const userInformation = loginEmail && loginPassword;

      if (
        error?.message === 'Request failed with status code 401' &&
        userInformation
      ) {
        setMessage('checkemail');
      }
    }
  };

  const handleKeyPress = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      void tryToAuthenticate();
    }
  };

  return (
    <div className="pb-5 border-b-rgrey-light border-b border-solid">
      {!resetVisible ? (
        <div
          className="flex flex-wrap justify-between pt-5"
          onKeyDown={handleKeyPress}
        >
          <h3 className="flex-[0_0_100%] pb-8 text-3xl leading-10 font-axi-bold">
            <Translate component="login" keyword="login-title" />
          </h3>

          <Input
            className="pb-5 lg:pb-2.5 lg:pr-2.5 px-0"
            type="email"
            name="loginEmail"
            id="loginEmail"
            keyword="email"
            value={loginEmail}
            onChange={(e) => setLoginEmail(e.target.value)}
          />

          <Input
            className="pb-5 lg:pb-2.5 lg:pr-2.5 px-0"
            type="password"
            name="loginPassword"
            id="loginPassword"
            keyword="password"
            value={loginPassword}
            onChange={(e) => setLoginPassword(e.target.value)}
          />

          <div className="flex items-center flex-[0_0_100%] pb-5 ">
            <button className="flex" onClick={() => void tryToAuthenticate()}>
              <p className="font-axi-bold cursor-pointer rounded-sm border text-sm px-5 py-3.5 border-solid border-rgrey-light hover:border-rgreen hover:text-white hover:border-solid hover:bg-rgreen bg-white">
                <Translate component="login" keyword="login-button" />
              </p>
            </button>
            <button
              className="underline cursor-pointer ml-auto lg:pr-2.5"
              onClick={setResetVisibility}
            >
              <Translate component="login" keyword="forgot-message" />
            </button>
          </div>

          <Alert show={!!message} type={Type.ERROR}>
            <Translate component="login-error" keyword={message} />
          </Alert>
        </div>
      ) : null}

      {resetVisible ? <ResetPassword toggle={setResetVisibility} /> : null}
    </div>
  );
};

export default Login;
